module.exports = __webpack_public_path__ + "img/loan_img_4.b03d5a1e.png";